import * as React from 'react';
import { JSSClassesProps } from 'react-jss';

import { ComponentJSSClasses } from './styles';
import { PopularityLabel } from '../../../../models/hotel-info';

import cl from 'classnames';


export interface HotelPopularityProps {
    popularityLevel: number;
}

export interface StyledHotelPopularityProps extends HotelPopularityProps, JSSClassesProps<ComponentJSSClasses> { }

export function HotelPopularity(props: StyledHotelPopularityProps) {
    const { classes: c } = props;

    if (props.popularityLevel === PopularityLabel.ExtremelyPopular) {
        return <span className={cl(c.container, c.green)}>Очень популярный</span>;
    }

    if (props.popularityLevel === PopularityLabel.Popular) {
        return <span className={cl(c.container, c.orange)}>Популярный</span>;
    }

    return null;
}

export default HotelPopularity;
